export enum FilterDataStatus {
    Loading = 'loading',
    Generic = 'generic',
}
